__turbopack_context__.v({
  "arrow1": "HowItWorks-module__W8Q5bq__arrow1",
  "arrow2": "HowItWorks-module__W8Q5bq__arrow2",
  "cageBalls": "HowItWorks-module__W8Q5bq__cageBalls",
  "howItWorks": "HowItWorks-module__W8Q5bq__howItWorks",
  "innerStep": "HowItWorks-module__W8Q5bq__innerStep",
  "prizesPopUp": "HowItWorks-module__W8Q5bq__prizesPopUp",
  "step": "HowItWorks-module__W8Q5bq__step",
  "step1": "HowItWorks-module__W8Q5bq__step1",
  "step2": "HowItWorks-module__W8Q5bq__step2",
  "step3": "HowItWorks-module__W8Q5bq__step3",
  "stepDescription": "HowItWorks-module__W8Q5bq__stepDescription",
  "stepTitle": "HowItWorks-module__W8Q5bq__stepTitle",
});
